<template>
  <div class="modal-overlay glass-background">
    <div class="modal-content">
      <slot></slot>
      <!--모달 내용-->
    </div>
  </div>
</template>

<script setup></script>

<style scoped lang="scss">
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1500;
}

.modal-content {
  display: flex;
  flex-direction: column;
  align-items: left;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  max-width: 75rem;
  height: 100dvh;
}

.glass-background {
  background: var(--surface-default);
  backdrop-filter: $blur-strongest;
  -webkit-backdrop-filter: $blur-strongest;
}
</style>
